import { useEffect } from 'react';

import { useQuery } from 'react-query';

import agreementsApi from 'api/rest/agreements/agreements';
import { useGlobalDialogContext } from 'context/GlobalDialogContext';
import useMeQuery from 'hooks/useMeQuery/useMeQuery';

const usePrivateRouteEvents = () => {
  const { data: userData, isLoading: userIsLoading } = useMeQuery();
  const { data: agreementsData, isLoading: agreementsDataLoading } = useQuery(
    agreementsApi.getAll.generateQueryKey({ hasConsent: false }),
    agreementsApi.getAll.request({ hasConsent: false }),
    { ...agreementsApi.getAll.requestBaseSettings, enabled: !!userData },
  );
  const { addToGlobalDialogQueue, GLOBAL_DIALOG } = useGlobalDialogContext();

  useEffect(() => {
    if (!userIsLoading && !agreementsDataLoading && userData) {
      const { isVerified, email, accountType, origin, isSchoolAccount, hasPasswordSet } = userData;
      const dialogsToOpen = [];

      if (!hasPasswordSet) dialogsToOpen.push({ type: GLOBAL_DIALOG.CHANGE_PASSWORD, props: { email }, priority: 1 });

      if (!isVerified) dialogsToOpen.push({ type: GLOBAL_DIALOG.VERIFY_ACCOUNT, props: { email }, priority: 1 });

      if ((!accountType || !origin) && !isSchoolAccount) dialogsToOpen.push({ type: GLOBAL_DIALOG.USER_INFO });

      if (agreementsData?.length) {
        agreementsData.forEach(({ title, content, file, id, validSince }) => {
          if (validSince < new Date()) {
            dialogsToOpen.push({
              type: GLOBAL_DIALOG.MISSING_AGREEMENT,
              priority: 2,
              props: {
                title,
                content,
                id,
                file,
              },
            });
          }
        });
      }

      if (dialogsToOpen.length) addToGlobalDialogQueue(dialogsToOpen);
    }
  }, [userData, userIsLoading, agreementsData]);

  return { isLoading: userIsLoading };
};

export { usePrivateRouteEvents };
